import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ReleaseProductSchema } from './shapes';

/** Field-conditional grants: nextBuildNumber/pinnedBranches → releases:config:manage, disabled → releases:products:manage. */
export const UpdateReleaseProductBodySchema = z
  .object({
    nextBuildNumber: z.number().int().min(1).optional(),
    pinnedBranches: z.array(z.string().trim().min(1).max(200)).max(20).optional(),
    disabled: z.boolean().optional(),
  })
  .strict()
  .refine((b) => Object.keys(b).length > 0, { message: 'At least one field is required' });
export type UpdateReleaseProductBody = z.infer<typeof UpdateReleaseProductBodySchema>;

export const updateReleaseProduct = defineEndpoint({
  method: 'PATCH',
  path: '/v1/release-products/:productId',
  params: z.object({ productId: z.string().uuid() }),
  query: z.object({}),
  body: UpdateReleaseProductBodySchema,
  response: z.object({ data: ReleaseProductSchema }),
});
